export class MaintenanceModeConfig {
  enabled: boolean;
  startDate: Date;
  endDate: Date;
  value: string;

  public isActive() {
    const now = new Date();
    return this.enabled && this.startDate.getTime() < now.getTime() && this.endDate.getTime() > now.getTime();
  }

  public isPlanned() {
    const now = new Date();
    return this.enabled && now.getTime() < this.startDate.getTime();
  }
}
